import { IconNameEnum, useModuleBEM } from "@b2bportal/core-themes";
import { CoreFlightsComponent } from "@b2bportal/core-types";
import { Icon } from "@b2bportal/core-ui";
import { ActionLink } from "@hopper-b2b/ui";
import clsx from "clsx";
import { FlightShopSearch, FlightSearchButton } from "./components";
import { useFlightShopTitle } from "./hooks/useFlightShopTitle";
import styles from "./styles.module.scss";

export const FlightShopTitle = ({ className = "" }) => {
  const [block, cn] = useModuleBEM(
    styles,
    CoreFlightsComponent.FlightShopTripDetails
  );

  const {
    context: {
      tripDate,
      showSearch,
      originLabel,
      destinationLabel,
      passengerCounts,
    },
    handlers: { onEditClick, onCloseSearch },
  } = useFlightShopTitle();

  return (
    <div className={clsx(block, className)}>
      <div className={cn("container")}>
        <span className={cn("close")}>
          <ActionLink content={<Icon iconName={IconNameEnum.close} />} />
        </span>

        <div className={cn("stop-container")}>
          <span className={cn("location")}>
            <span>{originLabel}</span>
            <Icon
              className={cn("airplane-icon")}
              iconName={IconNameEnum.airplane}
            />
            <span>{destinationLabel}</span>
          </span>

          <div className={cn("secondary-container")}>
            {`${tripDate} | ${passengerCounts}`}
          </div>
        </div>

        <FlightSearchButton showSearch={showSearch} onClick={onEditClick} />
      </div>

      {showSearch && (
        <div className={cn("search-container")}>
          <FlightShopSearch onSearch={onEditClick} onClose={onCloseSearch} />
        </div>
      )}
    </div>
  );
};
